import { useEffect } from 'react';
import { useOtpStore } from '@/store/otpStore';

/**
 * Register an inline OTP render surface for the lifetime of the calling
 * component. While at least one slot is registered, `<OtpModal>` yields and
 * renders nothing, so the OTP challenge surfaces inline instead of as the
 * centered popup.
 *
 * Use this directly when a feature renders its own bespoke OTP UI (e.g. the
 * inline withdraw verification step); use `<OtpSlot>` when the default
 * `<OtpForm>` is wanted.
 */
export function useOtpSlot(): void {
  const registerSlot = useOtpStore((s) => s.registerSlot);

  useEffect(() => {
    const deregister = registerSlot();
    return deregister;
  }, [registerSlot]);
}
